export const FOOD_PROGRAM_GET_SUCCESS = 'FOOD_PROGRAM_GET_SUCCESS';
export const FOOD_PROGRAM_GET_FAILURE = 'FOOD_PROGRAM_GET_FAILURE';

export const FOOD_PROGRAM_SUCCESS = 'FOOD_PROGRAM_SUCCESS';
export const FOOD_PROGRAM_FAILURE = 'FOOD_PROGRAM_FAILURE';
